import { render, staticRenderFns } from "./ResourceRequestAproveModal.vue?vue&type=template&id=266e0936"
import script from "./ResourceRequestAproveModal.vue?vue&type=script&lang=js"
export * from "./ResourceRequestAproveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports